import { render, staticRenderFns } from "./passportUpload.vue?vue&type=template&id=1a40701a&"
import script from "./passportUpload.vue?vue&type=script&lang=js&"
export * from "./passportUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports